import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PageWrapper from '@atresmedia/intranet-pagewrapper';

/** Core */
import ModalError from '../../../core/ModalError';
import { homeTxt } from '../../../../utils/literals/txt';

import {
  StyledPillText as PillText,
  StyledPillsWrapper as Pills,
  StyledPill as Pill,
  StyledButton,
  StyledTooltip,
  StyledTooltipContent,
  StyledTitleRRHH as Title,
  StyledContent,
  StyledBoxInfoContent
} from './style';
import Modal from '../../../core/Modal';
import Input from '../../../core/Input';
import Button from '../../../core/Buttons';
import WithholdingEmployees from '../../../containers/Employee/WithholdingRRHH/WithholdingEmployees';

const WithholdingRRHH = ({
  name,
  error,
  loading,
  roles,
  showList,
  isAdmin,
  isRRHH,
  getCertificate,
  onCloseModal,
  onCloseSearchModal,
  employeeSearched,
  searchModal,
  searchEmployeeById,
  sendEmailById,
  handleWithholding
}) => {
  const [value, setValue] = useState('');
  return (
    <StyledContent rrhh>
      <PageWrapper size="xl">
        {error.state && (
          <ModalError error={error.data} onCloseModal={() => onCloseModal()} />
        )}
        <Title>{homeTxt.title(name)}</Title>
        <Pills>
          {(!isRRHH || isAdmin) && (
            <Pill>
              <PillText>{homeTxt.altaRetenciones} </PillText>
              <StyledTooltip arrowPlacement="top">
                <StyledTooltipContent>{homeTxt.tooltip}</StyledTooltipContent>
              </StyledTooltip>
              <StyledButton
                disabled={loading}
                dark
                onClick={() => handleWithholding('altas_mail')}
              >
                {homeTxt.altaRetencionesBtn}
              </StyledButton>
            </Pill>
          )}
          {(!isRRHH || isAdmin) && (
            <Pill>
              <PillText>{homeTxt.bajaRetenciones}</PillText>
              <StyledButton
                disabled={loading}
                dark
                onClick={() => handleWithholding('bajas_mail')}
              >
                {homeTxt.bajaRetencionesBtn}
              </StyledButton>
            </Pill>
          )}
          <Pill>
            <PillText>{homeTxt.buscarEmpleado}</PillText>
            <StyledButton
              disabled={loading}
              dark
              onClick={() => handleWithholding('buscador')}
            >
              {homeTxt.buscadorRetencionesBtn}
            </StyledButton>
          </Pill>
          <Pill>
            <PillText>{homeTxt.verHistorico} </PillText>
            <StyledTooltip arrowPlacement="top">
              <StyledTooltipContent>{homeTxt.tooltip}</StyledTooltipContent>
            </StyledTooltip>
            <StyledButton
              disabled={loading}
              dark
              onClick={() => handleWithholding('ver_historico')}
            >
              {!showList
                ? homeTxt.verHistoricoBtn
                : homeTxt.ocultarHistoricoBtn}
            </StyledButton>
          </Pill>
        </Pills>
        {searchModal && !getCertificate && (
          <Modal className="transparent" searchModal>
            <Input
              name="inputRRHH"
              type="text"
              value={value}
              placeholder="ID del empleado"
              onChange={e => {
                setValue(e);
              }}
            />
            <Button
              primary
              isFloat
              onClick={() => {
                if (value.length > 0) {
                  searchEmployeeById(value);
                  setValue('');
                }
              }}
            >
              {'Buscar'}
            </Button>
            <Button
              secondary
              isFloat
              onClick={() => {
                onCloseSearchModal();
                setValue('');
              }}
            >
              {'X'}
            </Button>
          </Modal>
        )}
        {searchModal && getCertificate && employeeSearched !== null && (
          <Pills>
            <Pill>
              <PillText>{employeeSearched.userName}</PillText>
              <PillText>{employeeSearched.email}</PillText>
              <StyledBoxInfoContent>
                <StyledButton
                  primary
                  isFloat
                  margin
                  onClick={() => {
                    sendEmailById(employeeSearched.userId);
                    setValue('');
                  }}
                >
                  {'Enviar Certificado'}
                </StyledButton>
                <StyledButton
                  secondary
                  isFloat
                  margin
                  onClick={() => {
                    onCloseSearchModal();
                    setValue('');
                  }}
                >
                  {'Cancelar'}
                </StyledButton>
              </StyledBoxInfoContent>
            </Pill>
          </Pills>
        )}
        {roles.includes('ROLE_ACCESS_RRHH') && showList === true && (
          <WithholdingEmployees />
        )}
      </PageWrapper>
    </StyledContent>
  );
};

WithholdingRRHH.propTypes = {
  name: PropTypes.string,
  error: PropTypes.shape({
    state: PropTypes.bool,
    data: PropTypes.string
  }),
  searchModal: PropTypes.bool,
  onCloseModal: PropTypes.func,
  handleWithholding: PropTypes.func
};

const mapStateToProps = state => ({
  roles: state.user.user.roles
});

export default connect(mapStateToProps)(WithholdingRRHH);
